import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import './Accord.css';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



export default function SimpleAccordion() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  
  return (
    <div className='accord__container'>
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography  style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">01.</span>&nbsp;&nbsp;Can we use it as a liquid soap dispenser?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Yes it can be used as a soap dispenser & also as a  liquid dishwashing dispenser.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel2a-header"
        >
          <Typography  style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">02.</span>&nbsp;&nbsp;Does it come along with a stand.</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">No, the product is specially designed for wall mounting.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0}expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">03.</span>&nbsp;&nbsp;Does it dispense liquid as a flow (as drops) or does it discharge a spray of sanitiser.</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">It Dispenses Liquid.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>

        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel4a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">04.</span>&nbsp;&nbsp;How can I use this Device ?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Untouched smart sanitiser/soap dispenser is very easy to use you just have  to Place your hand at the bottom centre of the dispenser.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0}expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel5a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">05.</span>&nbsp;&nbsp;What do you call this machine?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">We named it Untouched.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel6a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">06.</span>&nbsp;&nbsp;Where can we get the liquid sanitiser?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">You can buy it from the local market & even online.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel7a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">07.</span>&nbsp;&nbsp;Can it be operated with batteries?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">No, this autonomous dispenser needs electricity.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel8a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">08.</span>&nbsp;&nbsp;Is this device portable?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Although we kept it lightweight, we have designed it specially for wall mounting.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel9a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">09.</span>&nbsp;&nbsp;How can I install the device?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">You can install it by just going through the provided user manual guide.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel10a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">10.</span>&nbsp;&nbsp;Does this product come with any warranty or guarantee?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">We are providing a 1 year warranty.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
        {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel11a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">11.</span>&nbsp;&nbsp;Any service charges?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath"> No service charges.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel12a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">12.</span>&nbsp;&nbsp;How do we refill the liquid sanitiser container?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Just open it from the top (with provided cap) & refill the inside bottle with liquid sanitiser.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel13a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">13.</span>&nbsp;&nbsp;Does it include the power adapter?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Yes, power adapter comes along with the package.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel14'} onChange={handleChange('panel14')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel14a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">14.</span>&nbsp;&nbsp;What's the dimensions of the product?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">293mm(h) X 154mm(l) X 120mm (w) </p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel15'} onChange={handleChange('panel15')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel15a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">15.</span>&nbsp;&nbsp;Can this be filled with gel type sanitiser?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Yes, it can be used with gel sanitiser.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel16'} onChange={handleChange('panel16')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel16a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">16.</span>&nbsp;&nbsp;What is Auto Sensing Distance of the dispenser?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Auto sensing distance between 200mm to 250mm.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel17'} onChange={handleChange('panel17')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel17a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">17.</span>&nbsp;&nbsp;What is the dispensing quantity of the product.</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Dispensing quantity of the product.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel18'} onChange={handleChange('panel18')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel18a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">18.</span>&nbsp;&nbsp;What will be the power consumption of the device in (Watt)?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">40 watt.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel19'} onChange={handleChange('panel19')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel19a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">19.</span>&nbsp;&nbsp;Is there any sanitiser level indicator?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">yes.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel20'} onChange={handleChange('panel20')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel20a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">20.</span>&nbsp;&nbsp;What will be the wait of the product?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">2.7 kg</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel21'} onChange={handleChange('panel21')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel21a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">21.</span>&nbsp;&nbsp;How can I order the product?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">You can order it from our website (untouched.soaron.co).</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel22'} onChange={handleChange('panel22')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel22a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">22.</span>&nbsp;&nbsp;Is cash on delivery available?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">yes it is available.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion sx={{marginBottom:1}} elevation={0} expanded={expanded === 'panel23'} onChange={handleChange('panel23')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
          aria-controls="panel1a-content"
          id="panel23a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">23.</span>&nbsp;&nbsp;What is the correct way to refill the sanitiser dispenser?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath">Firstly switch off the power of the adopter, open the top cap and refill it. (Use funnel for while refilling sanitiser to avoid wastage).</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      {/* ----- */}
      <Accordion  elevation={0} expanded={expanded === 'panel24'} onChange={handleChange('panel24')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}}/>}
          aria-controls="panel1a-content"
          id="panel24a-header"
        >
          <Typography style={{fontSize:'0.9rem',fontFamily: 'Lato'}}><span className="number">24.</span>&nbsp;&nbsp; What makes this product special from the rest in the market?</Typography>
        </AccordionSummary>
        
        <AccordionDetails   style={{backgroundColor:'white'}} >
          <Typography >
           <p className="beneath"> Apart from its sleeking minimal design & light weight it has been made with a smart sensor which will be ready to reuse in just 3 seconds.</p>
          </Typography>
        </AccordionDetails>
        </Accordion>
      
      
      
      
    </div>
  );
}

